import React from "react";
import {SelectInput} from "asocomponents"

function SelectTipoDocumento({onChange,width, etapa}) {
  const data=[ ]

  data.push({idTipoDocumento:"FCJ",descripcion:"Factura"})

  if (etapa==="I"){
    data.push({idTipoDocumento:"CDJ",descripcion:"Contestación de demanda"})
  }

  return (
    <div>
      <SelectInput options={data} placeholder="Tipo Documento" todos={false} onChange={onChange} defaultValue="-2" width={width} valueField="idTipoDocumento"></SelectInput>
    </div>
 )
}

export default SelectTipoDocumento